(function () {
  function openCartFallback() {
    const cartToggle =
      document.querySelector('[data-js-cart-trigger]') ||
      document.querySelector('[data-header-cart]') ||
      document.querySelector('a[href="/cart"]');

    if (cartToggle) {
      cartToggle.click();
    }
  }

  function setLoading(button, buttonText, wrapper, isLoading) {
    button.classList.toggle('is-loading', isLoading);
    button.disabled = isLoading;

    if (!buttonText) {
      return;
    }

    buttonText.textContent = isLoading
      ? wrapper.dataset.loadingText
      : wrapper.dataset.buttonText;
  }

  function showError(errorElement, message) {
    if (!errorElement) {
      return;
    }

    errorElement.textContent = message || 'Something went wrong. Please try again.';
    errorElement.hidden = false;
  }

  function hideError(errorElement) {
    if (!errorElement) {
      return;
    }

    errorElement.textContent = '';
    errorElement.hidden = true;
  }

  async function addFrequentlyBoughtSizes(wrapper) {
    const button = wrapper.querySelector('[data-ss-fbt-add]');
    const buttonText = wrapper.querySelector('[data-ss-fbt-button-text]');
    const errorElement = wrapper.querySelector('[data-ss-fbt-error]');

    const homeVariantId = Number(wrapper.dataset.homeVariantId);
    const travelVariantId = Number(wrapper.dataset.travelVariantId);

    if (!button || !homeVariantId || !travelVariantId) {
      return;
    }

    hideError(errorElement);
    setLoading(button, buttonText, wrapper, true);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: homeVariantId,
              quantity: 1
            },
            {
              id: travelVariantId,
              quantity: 1
            }
          ]
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || data.message || 'Could not add products to cart.');
      }

      if (typeof window.refreshCart === 'function') {
        window.refreshCart();
      } else {
        openCartFallback();
      }

      window.dispatchEvent(new CustomEvent('cart-updated'));
      window.dispatchEvent(new CustomEvent('aov:cart'));
    } catch (error) {
      showError(errorElement, error.message);
    } finally {
      setLoading(button, buttonText, wrapper, false);
    }
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-ss-fbt-add]');

    if (!button) {
      return;
    }

    const wrapper = button.closest('[data-ss-fbt-sizes]');

    if (!wrapper) {
      return;
    }

    addFrequentlyBoughtSizes(wrapper);
  });
})();